import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-primary">
      <div className="text-center text-white">
        <h1 className="text-[60px] font-bold">404</h1>
        <p className="text-[17px] mt-4">Oops, Page Not Found</p>
        <Link
          to="/admin"
          className="mt-6 inline-block px-6 py-2 text-blue-900 bg-white font-semibold rounded-lg shadow-md hover:bg-gray-200"
        >
          Back
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
